import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button, Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, Subscription, isModuleExist, subCoupon } from "../../utils/Constant";
import { deleteInvoiceApi, getAllSubscriptionInvoiceApi } from "./Api";
import PremimumPlanForm from "./PremimumPlanForm";
import { PREMIUM_PLAN_VERIFY } from "../../utils/urls";
import editPencil from "../../assets/images/edit-icon.png";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";
import moment from "moment";


export class Invoice extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.SubscriptionInvoice);

    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }


  // todo---------------------------------------
  componentDidMount() {
    const { history, access } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllSubscriptionInvoiceApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSearch = prevParams.get("search") || "";
    const prevSize = prevParams.get("pageSize") || "";
    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = params.get("pageSize") || "";
    const search = params.get("search") || "";
    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevSearch !== search || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllSubscriptionInvoiceApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {
    //  console.log("yes delete  this id",)
    deleteInvoiceApi(id, this, this.openCloseDeleteModal)
  }

  getDetailsUser = (url) => {
    window.open(url, "_blank")
  }

  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete  '${this.state.deleteData.name}' Plan ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}

        <VerifiedModal
          name={`'${this.state.editData?.name}'`}
          show={this.state.show}
          url={"invoice/verify" + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllSubscriptionInvoiceApi(this) }}
        />
        {
          showEdit &&
          <PremimumPlanForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Invoice"
          breadcrumb={[["Subscription", ""], ["Invoice", ""]]}
          primaryBtn={access.createAccess ? "Add Invoice" : ""}
          handlePrimaryBtn={() => {
            this.props.history('/invoice/form');
            // this.setState({showEdit:true})
          }}
          ctx={this}
        />
        {/* <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row> */}
        <div className="commom-table-wrapper">
          <CustomTable
            ctx={this}
            data={listData?.list || []}
            columns={[

              {
                width: 150,
                title: "User Id ",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData?.userId;
                }
              },
              {
                width: 150,
                title: "Email ",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData?.emailAddress;
                }
              },
              {
                width: 150,
                title: "Invoice #",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return <>
                    {rowData?.invoiceNo}
                  </>;
                }
              },
              {
                width: 150,
                title: "Bill Amount",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return <>
                    {rowData?.billAmount}
                  </>;
                }
              },
              {
                width: 150,
                title: "Invoice Date",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return moment(rowData?.invoiceDate).format("lll");
                },
              },
              {
                width: 150,
                title: "Generated By",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData?.isSystemGenerated ? "System" : "Admin"
                },
              },
              {
                // width: 150,
                width: 20,

                title: "Action",
                dataIndex: "",
                className: "",
                fixed: "right",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return (
                    // <div className="d-flex gap-4 justify-content-around">

                    //   {access.updateAccess && (
                    //     <Image src={editIcon} className="edit-icon" onClick={() => { this.props.history({ pathname: '/premimum-planForm', state: { editData: rowData } }) }} />
                    //   )}
                    //   {access.deleteAccess && (
                    //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                    //   )}
                    // </div>
                    <div className="d-flex gap-12 justify-space-between align-items-center">
                      {rowData.invoicePdfPath && <a href={rowData.invoicePdfPath} target="_blank">View</a>}
                      {(access.updateAccess && !rowData.isSystemGenerated) && (access.deleteAccess && !rowData.isSystemGenerated) && !rowData.isSystemGenerated && <OptionsDropdown
                        editHandler={(access.updateAccess && !rowData.isSystemGenerated) ? () => { this.props.history({ pathname: '/invoice/form', state: { editData: rowData } }) } : null}
                        deleteHandler={(access.deleteAccess && !rowData.isSystemGenerated) ? () => { this.openCloseDeleteModal(rowData) } : null}
                      />
                      }
                    </div>
                  );
                }

              },
            ]}

            total={listData?.length || 0}
            loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllSubscriptionInvoiceApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Invoice));
